"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var LocalizedLanguageSetter = (function () {
    function LocalizedLanguageSetter() {
    }
    LocalizedLanguageSetter.prototype.setLocalizedValues = function (languages) {
        for (var _i = 0, languages_1 = languages; _i < languages_1.length; _i++) {
            var language = languages_1[_i];
            language.label = csod.locales.get(language.label, language.label);
        }
    };
    return LocalizedLanguageSetter;
}());
exports.LocalizedLanguageSetter = LocalizedLanguageSetter;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/LocalizedLanguageSetter.ts
// module id = 295
// module chunks = 0